export const SMILES_UTM_SOURCE = 'smiles'

export const SMILES_PROGRAM = 'SMILES'

export const SMILES_DEFAULT_CONVERSION_FACTOR = 0.009

export const SMILES_PARAM_UTM_SOURCE = 'utm_source'
export const SMILES_PARAM_ACCOUNT_NUMBER = 'accountNumber'
export const SMILES_PARAM_AUTH_TOKEN = 'authToken'
export const SMILES_PARAM_PARTNER_ID = 'partner_id'

export const SMILES_COOKIE_NAME = 'smilesSession'

export const SMILES_COOKIE_TTL_DAYS = 1 / 24

export const SMILES_FAQ_URL = 'https://www.cleartrip.ae/lp/smiles-faq'

export const SMILES_VERIFICATION_PATH = '/itin/smile/userVerification'
